import React from 'react';
import { useIntl } from 'react-intl';

import Select from '@starbucks-web/pattern-library/lib/components/select';

import { usePdpContext } from '../pdp-provider';

import messages from './messages';

const DropdownSizeSelector = ({ onClick = () => {} }) => {
  const { formatNumber, formats } = useIntl();
  const { isDemystifyMenuPdpEnabled, onSizeSelect, sizeInfo } = usePdpContext();
  const { formatMessage } = useIntl();

  const { pricedProductAllSizes = new Map() } = sizeInfo || {};

  const getProductSizePrice = (sizeSku) => {
    if (!isDemystifyMenuPdpEnabled || !pricedProductAllSizes?.has(sizeSku))
      return '';
    return `, ${formatNumber(pricedProductAllSizes.get(sizeSku), formats.number.money)}`;
  };

  const selectedOptionFormatterHandler = (selectedOption) => {
    if (!isDemystifyMenuPdpEnabled) return selectedOption?.text;

    const text = selectedOption?.text || [];
    if (!text.length) return '';

    const selectedSizeLabel = text.slice(0, 2).join(' ');
    const selectedSizePrice = text[2]?.replace(/, /g, '') || '';

    return (
      <div className="flex justify-between items-center">
        <span>{selectedSizeLabel}</span>
        <span className="text-xs color-black60">{selectedSizePrice}</span>
      </div>
    );
  };

  return (
    <Select
      className="mb5"
      data-e2e="size-selector"
      id="sizeSelector"
      label={formatMessage(messages.sizeLabel)}
      onChange={(ev) => onSizeSelect(ev.target.value)}
      onClick={onClick}
      selectedOptionFormatter={selectedOptionFormatterHandler}
      value={sizeInfo?.selectedSizeName}
    >
      {sizeInfo?.sizeNames?.map((size, index) => {
        const productSizePrice = getProductSizePrice(
          sizeInfo?.sizeSkus?.[index]
        );

        return (
          <option key={size} value={size}>
            {size}
            {sizeInfo?.sizeAmounts[index]}
            {productSizePrice}
          </option>
        );
      })}
    </Select>
  );
};

export default DropdownSizeSelector;
